import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { pluck } from "rxjs";
import { UserManagementService } from "../services/user-management.service";

export const SidebarResolver: ResolveFn<string> = () => {
  const loginService = inject(UserManagementService);
  return loginService.validateLogin().pipe(pluck("data", "userRole"));
};
